import React, { useEffect, useState } from "react";
import { DataGridPro, GridColDef, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { config } from "../../Constants";
import { InsuranceCompanyModel } from "../../models/insuranceCompanyModel";
import { Add } from "@mui/icons-material";
import Moment from 'moment';
import { AddEditInsuranceCompany } from "../AddEdit/AddEditInsuranceCompany";
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { formatUtcToLocal } from "../../helper/utils";
import useAuth from "../../context/AuthProvider";
import { AddEditCarriermanagement } from "../AddEdit/AddEditCarrierManagement";
import { stateOptions } from "../AddEdit/AddEditPartners";
import { RiExpandUpDownLine } from "react-icons/ri";
import Swal from "sweetalert2";
import { AddEditCarrierManageLineOfBussinessCheckBox } from "../AddEdit/AddEditCarrierManageLineOfBussinessCheckBox";
import { apiClient } from "../../helper/api";
import {KeyboardArrowUp, KeyboardArrowDown} from '@mui/icons-material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import RestoreFromTrashOutlinedIcon from '@mui/icons-material/RestoreFromTrashOutlined';


interface Iprops {
    InsuranceComapnyCL: InsuranceCompanyModel[],
    fetchData: () => void,
    handleMappingsUpdate: () => void
    sortModel: any;
    setSortModel: React.Dispatch<React.SetStateAction<any>>;
}

export interface lineOfBusinessModel {
    id: number, businessCode: string, stateId: number
}





export const CarrierManagementList: React.FC<Iprops> = ({ InsuranceComapnyCL, fetchData, handleMappingsUpdate, sortModel, setSortModel }) => {
    const initialICData: InsuranceCompanyModel = {
        insuranceCompanyId: 0, naicNumber: "", name: "", stateId: 0, createdBy: 0, modifiedBy: 0, dateCreated: new Date(), dateModified: new Date(), isDeleted: false,
        stateName: "", isActive: true
    };

    const { user } = useAuth();
    const token = user?.token;
    const [selectedStates, setselectedStates] = useState<stateOptions[]>([]);
    const [States, setStates] = useState<stateOptions[]>([]);
    const [value, setValue] = React.useState(0);
    const [selectedLineOfBusiness, setselectedLineOfBusiness] = useState<lineOfBusinessModel[]>([]);
    const [LineOfBusiness, setLineOfBusiness] = useState<lineOfBusinessModel[]>([]);

    const [Open, setOpen] = React.useState(false);
    const [Open1, setOpen1] = React.useState(false);
    const [Formdata, setFormData] = React.useState(initialICData);
    const [currentState, setCurrentState] = React.useState(0);

    const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked) {

            var id = Number(event.target.name);
            setCurrentState(id);
            getLineOfBusinessByStateId(id);

            console.log(event.target.name);
            let crrOption: stateOptions = {
                stateId: Number(event.target.name),
                stateName: '',
            }
            setselectedStates(current => [...current, crrOption])
        }

        else {
            Swal.fire({
                title: 'Are you sure?',
                text: "Do you want to remove all line of business related to this state",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, remove them!'
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        var id = Number(event.target.name);
                        for (var i = 0; i < selectedLineOfBusiness.length; i++) {
                            if (selectedLineOfBusiness[i].stateId == id) {
                                selectedLineOfBusiness[i].businessCode = "";
                                selectedLineOfBusiness[i].stateId = 0;
                                selectedLineOfBusiness[i].id = 0;
                                // var index = selectedLineOfBusiness.indexOf(selectedLineOfBusiness[i]);
                                // delete selectedLineOfBusiness[index];
                                // const index1 = selectedLineOfBusiness.indexOf(index);
                            }
                        }
                        setselectedStates(
                            selectedStates.filter(obj =>
                                obj.stateId != Number(event.target.name)
                            )
                        )
                    }
                })
        }
    };

    const handleStateEdit = (eventId: number) => {
        setCurrentState(eventId);
        getLineOfBusinessByStateId(eventId)

    }


    function getLineOfBusinessByStateId(id: number) {
        //setloading(true)
        apiClient("/LineOfBusiness/getLineOBusinessByStateId?stateId=" + `${id}`,
            {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }),
                method: "Get",
            }
        )
            .then((res) => {
                if (!res) return
                if (res.data.length > 0) {
                    setOpen1(true);
                    setLineOfBusiness(res.data);
                } else {
                    alert("There is no line of business for this state");
                }

            })

    }

    function selectAll() {
        setselectedStates(States);
    }

    const handleLineOfBusinessCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            console.log(event.target.name);
            var curntState = currentState;
            let crrOption: lineOfBusinessModel = {
                id: Number(event.target.name),
                businessCode: '',
                stateId: curntState
            }

            setselectedLineOfBusiness(current => [...current, crrOption]);

        } else {

            setselectedLineOfBusiness(
                selectedLineOfBusiness.filter(obj =>
                    obj.id != Number(event.target.name)
                )
            )
        }

    };
    const handleDelete = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            // icon: null, // Remove the icon property
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    apiClient("/InsuranceCompany/DeleteInsuranceCompany?id=" + `${id}`,
                        {
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            method: "Delete",
                        }
                    )
                        .then((res) => {
                            if (!res) return
                            Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            )

                            fetchData();
                            setOpen(false);
                        }).catch((error) => {
                            console.log(error)
                        });
                  
                }
            })
        //call api to save data
        // fetch(config.url.API_URL + "/Users/Delete?id=" + `${id}`,
        //     {
        //         headers: new Headers({
        //             'Content-Type': 'application/json',
        //             'Authorization': `Bearer ${token}`,
        //         }),
        //         method: "Delete",
        //     }
        // )
        //     .then((response) => {
        //         if (response.ok) {
        //             return response.json();
        //         }
        //         throw new Error('Something went wrong');
        //     })
        //     .then((res) => {
        //         alert("Data Successfully Deleted")
        //         fetchData();
        //         setOpen(false);
        //     }).catch((error) => {
        //         console.log(error)
        //     });


    };

    const columns: GridColDef[] = [
        { field: 'naicNumber', headerName: 'NAIC #', type: 'string', flex: 0.5, headerAlign: 'left',hideSortIcons: true, minWidth: 100,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'naicNumber'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, align: 'left' },
        { field: 'name', headerName: 'Carrier', flex: 1.5, headerAlign: 'left',hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'name'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, align: 'left' },

        {
            field: 'startDate', headerName: 'Start Date', type: "date", flex: 0.5,hideSortIcons: true, minWidth: 130,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'startDate'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, headerAlign: 'left', align: 'left', renderCell: (params) => (
                <div> {params.row.startDate ? formatUtcToLocal(params.row.startDate, "MM-DD-YYYY") : ""}</div>)

        },


        // { field: 'startDate', headerName: 'Start Date', type: "date", flex: 0.5, renderCell: (params) => (<div> {params.row.startDate ? Moment(params.row.startDate).format("YYYY-MM-DD") : ""}</div>) },
        { field: 'dateModified', headerName: 'Last Modified', type: "date", flex: 0.5,hideSortIcons: true, minWidth: 130,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'dateModified'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, headerAlign: 'left', align: 'left', renderCell: (params) => (<div> {params.row.dateModified ? formatUtcToLocal(params.row.dateModified, "MM-DD-YYYY") : ""}</div>) },
        {
            field: 'id',
            sortable: false,
            disableColumnMenu: true,

            flex: 0.5, headerName: "Action", headerAlign: 'center', align: 'center',hideSortIcons: true, minWidth: 130,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), renderCell: (params) => (<div>
                <IconButton
                    color="primary"
                    onClick={() => { handleEdit(params.row) }}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                >
                    <Tooltip
                        title="Edit"
                        placement="top"
                        arrow
                    >
                    <EditOutlinedIcon fontSize="small" color="primary" />
                    </Tooltip>
                </IconButton >
                {user?.userRoles.split(",").includes("Super Admin") ?
                    <IconButton
                        color="error"
                        onClick={() => { handleDelete(params.row.insuranceCompanyId) }}
                        sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(211,48,47,0.15) !important' } }}
                    >
                        {params.row.isDeleted ? <RestoreFromTrashOutlinedIcon /> :
                        <Tooltip
                            title="Delete"
                            placement="top"
                            arrow
                        >
                            <DeleteOutlineOutlinedIcon fontSize="small" color="error" />
                        </Tooltip>
                        }
                    </IconButton >
                    : ""}
            </div>)
        }


    ];

    const handleClickOpen = () => {
        setselectedStates([]);
        setselectedLineOfBusiness([]);
        fetchStates(0);
        fetchLineOfBusiness(0);
        setFormData(initialICData);
        setOpen(true);
    };
    const handleClose = () => {
        setselectedLineOfBusiness([]);
        setOpen(false);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };
    const handleSubmit = () => {
        fetchData();
        setOpen(false);
    };
    const handleSubmitLineofBusinessByState = () => {
        setOpen1(false);
    };

    const fetchStates = (insuranceCompanyId: number) => {

        apiClient('/States/getStates',
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response

                setStates(responseJson.data);
                // console.log(States);

            }).then(() => {
                apiClient(`/InsuranceCompany/getInsuranceCompanyStates?insuranceCompanyId=${insuranceCompanyId}`,
                    {
                        method: "GET",
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        })
                    })
                    .then((responseJson) => {
                        if (!responseJson) return
                        // Do something with the response

                        setselectedStates(responseJson.data);
                        // setSelectedOption(States.filter(x => partnerStates.map((item)=>(item.stateId))));
                    })
            })


    }


    const fetchStateData = () => {

        apiClient('/States/getStates',
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response

                setStates(responseJson.data)

            })


    }


    useEffect(() => {

        fetchStateData();
    }, [])





    const fetchLineOfBusiness = (insuranceCompanyId: number) => {

        if (insuranceCompanyId > 0) {
            // fetch(config.url.API_URL + '/LineOfBusiness/getLineOBusinessForSelect',
            //     {
            //         method: "GET",
            //         headers: new Headers({
            //             'Content-Type': 'application/json',
            //             'Authorization': `Bearer ${token}`,
            //         })
            //     }).then((response) => {
            //         if (response.ok) {
            //             return response.json();
            //         }
            //         throw new Error('Something went wrong');
            //     })
            //     .then((responseJson) => {
            //         // Do something with the response

            //         //setLineOfBusiness(responseJson.data);
            //         // console.log(States);

            //     }).then(() => {
            apiClient(`/InsuranceCompany/getInsuranceCompanyLineOfBusiness?insuranceCompanyId=${insuranceCompanyId}`,
                {
                    method: "GET",
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    })
                })
                .then((responseJson) => {
                    if (!responseJson) return

                    // Do something with the response
                    setselectedLineOfBusiness(responseJson.data);
                    // for (let i = 0; i < responseJson.data.length; i++) {
                    //     var id=Number(responseJson.data[i].id)
                    //     setselectedLineOfBusiness(responseJson.data);
                    // }
                })

            // }).catch((error) => {
            //     console.log(error)

            // });
        }
    }

    const handleEdit = (ICClData: InsuranceCompanyModel) => {



        setselectedStates([]);
        setselectedLineOfBusiness([]);

        ICClData.startDate = ICClData.startDate ? ICClData.startDate.toString().split('T')[0] : "";
        console.log(ICClData);

        setFormData(ICClData);
        fetchStates(ICClData.insuranceCompanyId);
        fetchLineOfBusiness(ICClData.insuranceCompanyId);
        setOpen(true);
    };

    function EditToolbar() {
        return (
            <Box sx={{
                borderBottom: 1,
                borderColor: 'divider',
                p: 1,
            }}>
                <GridToolbarFilterButton />
            </Box>
        );
    }

    return (
        <React.Fragment>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 1.5,
                        px: { xs: 4, lg: 2 },
                        py: 1.5,
                        borderBottom: '1px solid #e2e8f0',
                        backgroundColor: '#fafbfc',
                        minHeight: 56,
                        mb: 3,
                        marginLeft: { xs: '-24px', lg: '0px' },
                        marginRight: { xs: '-24px', lg: '0px' },
                    }}
                >
                    <h4 className="mb-0" style={{ fontWeight: 600, color: '#0f172a' }}>
                        Carrier Management
                    </h4>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button
                            variant="contained"
                            size="medium"
                            onClick={handleClickOpen}
                            startIcon={<Add />}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                backgroundColor: '#2099d2',
                                '&:hover': { backgroundColor: '#176990' },
                            }}
                        >
                            Add New
                        </Button>
                        {(config === "http://localhost:5274/api" || ("https://filemule-api.azurewebsites.net/api")) ? (
                            <Button
                                variant="outlined"
                                size="medium"
                                onClick={handleMappingsUpdate}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    borderColor: '#e2e8f0',
                                    color: '#475569',
                                    '&:hover': {
                                        borderColor: '#2099d2',
                                        backgroundColor: '#2099d214',
                                        color: '#2099d2',
                                    },
                                }}
                            >
                                Push to live
                            </Button>
                        ) : null}
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                        border: '1px solid #e2e8f0',
                        backgroundColor: '#ffffff',
                        height: 'calc(100vh - 250px)',
                    }}
                >
                    <DataGridPro
                        getRowId={(r) => r.insuranceCompanyId}
                        rows={InsuranceComapnyCL}
                        columns={columns}
                        pageSize={50}
                        rowsPerPageOptions={[10]}
                        components={{
                            Toolbar: EditToolbar,
                        }}
                        onSortModelChange={(newSortModel: any) => setSortModel(newSortModel)}
                        sortModel={sortModel}
                        experimentalFeatures={{ newEditingApi: true }}
                        sx={{
                            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                            border: 'none',
                            fontSize: '14px',
                            color: '#475569',
                            backgroundColor: '#ffffff',
                            '& .MuiDataGridPro-columnHeaderTitle': {
                                whiteSpace: 'normal',
                                lineHeight: 1.35,
                                fontWeight: 600,
                                fontSize: '12px',
                                letterSpacing: '0.05em',
                                textTransform: 'uppercase',
                                color: '#64748b',
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#f8fafc',
                                borderBottom: '2px solid #e2e8f0',
                                borderTop: '2px solid #e2e8f0',
                                minHeight: '52px !important',
                                maxHeight: '52px !important',
                            },
                            '& .MuiDataGrid-columnHeader': {
                                '&:focus, &:focus-within': { outline: 'none' },
                            },
                            '& .MuiDataGrid-row': {
                                transition: 'background-color 0.15s ease',
                                '&:nth-of-type(even)': {
                                    backgroundColor: '#fafbfc',
                                },
                                '&:hover': {
                                    backgroundColor: '#f1f5f9 !important',
                                },
                            },
                            '& .MuiDataGrid-cell': {
                                borderBottom: '1px solid #f1f5f9',
                                fontSize: '14px',
                                color: '#334155',
                                overflow: 'visible',
                                whiteSpace: 'normal',
                                lineHeight: 'normal',
                                wordWrap: 'break-word',
                                textOverflow: 'clip',
                                padding: '8px 16px',
                                '&:focus': { outline: 'none' },
                            },
                            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                marginBottom: '0px !important',
                            },
                            '& .MuiDataGrid-virtualScroller': {
                                border: 'none',
                            },
                            '& .MuiDataGrid-main': {
                                border: 'none',
                            },
                            '& .MuiDataGrid-footerContainer': {
                                borderTop: '1px solid #e2e8f0',
                                backgroundColor: '#f8fafc',
                                minHeight: 56,
                            },
                            '& .MuiTablePagination-root': {
                                color: '#64748b',
                                fontSize: '13px',
                            },
                            '& .MuiTablePagination-select': {
                                fontSize: '13px',
                                borderRadius: '6px',
                                border: '1px solid #e2e8f0',
                            },
                            '& .MuiIconButton-root': {
                                color: '#64748b',
                                '&:hover': {
                                    backgroundColor: '#f1f5f9',
                                    color: '#475569',
                                },
                            },
                        }}
                    />
                </Box>
                <AddEditCarriermanagement setselectedLineOfBusiness={setselectedLineOfBusiness} handleClose={handleClose} Open={Open} InsuranceCompanyCL={Formdata} handleSubmit={handleSubmit} initValues={initialICData} selectedStates={selectedStates} States={States} setselectedStates={setselectedStates} setStates={setStates} handleCheckBoxChange={handleCheckBoxChange} selectedLineOfBusiness={selectedLineOfBusiness} LineOfBusiness={LineOfBusiness} handleLineOfBusinessCheckBoxChange={handleLineOfBusinessCheckBoxChange} selectAll={selectAll} handleStateEdit={handleStateEdit} ></AddEditCarriermanagement>
                <AddEditCarrierManageLineOfBussinessCheckBox currentState={currentState} handleClose={handleClose1} Open={Open1} InsuranceCompanyCL={Formdata} handleSubmit={handleSubmitLineofBusinessByState} initValues={initialICData} selectedStates={selectedStates} States={States} setselectedStates={setselectedStates} setStates={setStates} handleCheckBoxChange={handleCheckBoxChange} selectedLineOfBusiness={selectedLineOfBusiness} LineOfBusiness={LineOfBusiness} handleLineOfBusinessCheckBoxChange={handleLineOfBusinessCheckBoxChange} selectAll={selectAll} ></AddEditCarrierManageLineOfBussinessCheckBox>


            </div>
        </React.Fragment>
    )
}